/**
 * Handlers for <input type="number"> that must accept positive integers only.
 * Blocks scientific notation (e/E), signs (+/-), and decimals (. ,).
 */

const BLOCKED_KEYS = new Set(['e', 'E', '+', '-', '.', ',']);

const ALLOWED_CONTROL_KEYS = new Set([
  'Backspace',
  'Delete',
  'Tab',
  'Escape',
  'Enter',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
]);

export function blockIntegerNumberInputKeyDown(e) {
  if (ALLOWED_CONTROL_KEYS.has(e.key)) {
    return;
  }
  if (e.ctrlKey || e.metaKey) {
    return;
  }
  if (BLOCKED_KEYS.has(e.key)) {
    e.preventDefault();
    return;
  }
  if (/^\d$/.test(e.key)) {
    return;
  }
  e.preventDefault();
}

export function blockIntegerNumberInputPaste(e) {
  const text = e.clipboardData?.getData('text')?.trim() ?? '';
  if (text === '') {
    return;
  }
  if (!/^\d+$/.test(text)) {
    e.preventDefault();
  }
}

export function preventNumberInputWheel(e) {
  e.currentTarget.blur();
}
